import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
import { computed, onBeforeMount, onMounted, onUnmounted, ref, watch, } from "vue";
import { useRouter } from "vue-router";
import InventoryBrandsAndMarketsTable from "@/components/templates/Inventory/InventoryBrandsAndMarketsTable.vue";
import InventoryWebsitesTable from "@/components/templates/Inventory/InventoryWebsitesTable.vue";
import OneDeskAnomalyColumn from "@/components/atoms/OneDeskAnomalyColumn.vue";
import WebSiteLink from "@/components/molecules/WebSiteLink.vue";
import OneDeskInventoryNoResult from "@/components/atoms/OneDeskInventoryNoResult.vue";
import { getInventoryDataPaginated, getInventoryWebsitesDataByCriteriaPaginated } from "@/repositories/inventory.repository";
import { inventoryColumns } from "@/shared/utils/columns-definition/inventory";
import InventorySearch from "@/components/templates/Inventory/InventorySearch.vue";
import { AllActionTypes } from "@/store/action-types";
import { ReferenceValuesTypes } from "@/store/modules/reference-values/types";
import OneDeskCard from "@/components/molecules/OneDeskCard.vue";
import { useStore } from "@/shared/composables/useStore";
import { SearchTarget } from "@/shared/enums/SearchTarget.enum";
export default /*#__PURE__*/ _defineComponent({
    __name: 'InventoryView',
    setup(__props) {
        const store = useStore();
        const router = useRouter();
        const loading = ref(false);
        const inventory = ref({ items: [], totalCount: 0, pageIndex: 1, totalPages: 0 });
        const brandsAndMarkets = ref({ items: [], totalCount: 0, pageIndex: 1, totalPages: 0 });
        const inventoryRef = ref();
        const pageNumber = ref(1);
        const pageSize = ref(10);
        const checkboxStyle = ref("p-md-6");
        const displayNoResult = computed(() => {
            return searchCriteria.value.searchTarget === SearchTarget.site ? inventory.value.items.length === 0 : brandsAndMarkets.value.items.length === 0;
        });
        const searchCriteria = computed(() => store.getters.getInventorySearch);
        onBeforeMount(async () => {
            await store.dispatch(AllActionTypes.GET_REFERENCE_VALUES, ReferenceValuesTypes.BRANDS);
            await store.dispatch(AllActionTypes.GET_REFERENCE_VALUES, ReferenceValuesTypes.MARKETS);
            await searchInInventoryOrBrandsAndMarkets();
        });
        const searchInInventoryOrBrandsAndMarkets = async () => {
            if (searchCriteria.value.searchTarget === SearchTarget.site) {
                await retrieveInventoryWebsitesPaginated();
            }
            else {
                await retrieveBrandsAndMarketsPaginated();
            }
        };
        const retrieveBrandsAndMarketsPaginated = async () => {
            loading.value = true;
            brandsAndMarkets.value = await getInventoryDataPaginated(pageNumber.value, pageSize.value, searchCriteria.value.searchTarget, searchCriteria.value.allWebsitesChecked);
            loading.value = false;
        };
        const retrieveInventoryWebsitesPaginated = async () => {
            loading.value = true;
            inventory.value = await getInventoryWebsitesDataByCriteriaPaginated(pageNumber.value, pageSize.value, searchCriteria.value.searchText, searchCriteria.value.brands, searchCriteria.value.markets, searchCriteria.value.allWebsitesChecked, searchCriteria.value.hasSyncIssues);
            loading.value = false;
        };
        const columnsDefinition = computed(() => {
            const groupBy = searchCriteria.value.searchTarget;
            return [
                {
                    field: SearchTarget[groupBy],
                    header: groupBy == SearchTarget.brand ? "Brand" : "Market",
                    type: "string",
                    hasFilter: false,
                    hasSlot: false,
                    sortable: false,
                },
                {
                    field: "websiteCount",
                    header: "Count websites",
                    type: "string",
                    hasFilter: false,
                    hasSlot: false,
                    sortable: false,
                },
                {
                    field: "anomalies",
                    header: "Anomalies",
                    type: "string",
                    hasFilter: false,
                    hasSlot: true,
                    sortable: false,
                },
                {
                    field: groupBy === SearchTarget.brand ? "division" : "zone",
                    header: groupBy === SearchTarget.brand ? "Division" : "Zone",
                    type: "string",
                    hasFilter: false,
                    hasSlot: false,
                    sortable: false,
                },
            ];
        });
        const columnsDefinitionSubTable = ref(inventoryColumns);
        const updateSearchText = async (text) => {
            if (text !== "")
                updateSearchCriteria({ ...searchCriteria.value, searchText: text, searchTarget: SearchTarget.site });
            else
                updateSearchCriteria({ ...searchCriteria.value, searchText: text, searchTarget: SearchTarget.brand });
            await searchInInventoryOrBrandsAndMarkets();
        };
        watch(pageNumber, async () => {
            await searchInInventoryOrBrandsAndMarkets();
        });
        watch(searchCriteria, async () => {
            pageNumber.value = 1;
            await searchInInventoryOrBrandsAndMarkets();
        }, { deep: true });
        const onWebsiteRowClick = (data) => {
            router.push({
                name: "Website",
                params: {
                    slug: data.slug,
                },
            });
        };
        const onBrandOrMarketRowClick = (record) => {
            if (searchCriteria.value.searchTarget === SearchTarget.brand)
                setSearchCriteria(undefined, record.data.brand);
            else if (searchCriteria.value.searchTarget === SearchTarget.market)
                setSearchCriteria(record.data.market, undefined);
            pageNumber.value = 1;
            retrieveInventoryWebsitesPaginated();
        };
        const updateSearchCriteria = (criteria) => {
            store.dispatch(AllActionTypes.SET_INVENTORY_SEARCH, criteria);
        };
        const setSearchCriteria = (market, brand) => {
            updateSearchCriteria({
                searchText: "",
                allWebsitesChecked: searchCriteria.value.allWebsitesChecked,
                searchTarget: SearchTarget.site,
                brands: brand ? [brand] : [],
                markets: market ? [market] : [],
                searchPerimeter: [SearchTarget.market, SearchTarget.brand, SearchTarget.site],
                hasSyncIssues: searchCriteria.value.hasSyncIssues,
            });
            updateDisplayFilters(true);
        };
        const updateDisplayFilters = (display) => {
            store.dispatch(AllActionTypes.SET_DISPLAY_FILTERS, display);
        };
        onMounted(() => {
            window.addEventListener("resize", myEventHandler);
            myEventHandler();
        });
        onUnmounted(() => {
            window.removeEventListener("resize", myEventHandler);
        });
        const myEventHandler = () => {
            const withoutPaddingStyle = "padding-top: 0;padding-left: 0.5rem";
            const withPaddingStyle = "padding-top: 1.5em;padding-left: 5rem";
            if (inventoryRef.value && inventoryRef.value.clientWidth > 0) {
                if (inventoryRef.value.clientWidth < 985)
                    checkboxStyle.value = withoutPaddingStyle;
                else
                    checkboxStyle.value = withPaddingStyle;
            }
        };
        const clearFilters = () => {
            updateSearchCriteria({
                searchText: "",
                allWebsitesChecked: false,
                searchTarget: SearchTarget.brand,
                brands: [],
                markets: [],
                searchPerimeter: [SearchTarget.market, SearchTarget.brand, SearchTarget.site],
                hasSyncIssues: false,
            });
            pageNumber.value = 1;
            retrieveBrandsAndMarketsPaginated();
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "page-container",
                ref_key: "inventoryRef",
                ref: inventoryRef
            }, [
                _createVNode(OneDeskCard, {
                    title: "Inventory",
                    "data-testid": "inventory-card",
                    "has-search": true,
                    "search-text": searchCriteria.value.searchText,
                    "onUpdate:searchText": _cache[2] || (_cache[2] = ($event) => (updateSearchText($event))),
                    onClearFilters: clearFilters
                }, {
                    filters: _withCtx(() => [
                        _createVNode(InventorySearch, {
                            "data-testid": "inventory-search",
                            "model-value": searchCriteria.value,
                            "onUpdate:modelValue": updateSearchCriteria
                        }, null, 8, ["model-value"])
                    ]),
                    content: _withCtx(() => [
                        (searchCriteria.value.searchTarget !== _unref(SearchTarget).site)
                            ? (_openBlock(), _createBlock(InventoryBrandsAndMarketsTable, {
                                key: 0,
                                "data-testid": "inventory-brands-and-markets-table",
                                "table-data": brandsAndMarkets.value.items,
                                "columns-definition": columnsDefinition.value,
                                "has-pagination": true,
                                "header-class": "website-table-header",
                                "on-row-click": onBrandOrMarketRowClick,
                                "grouped-value": searchCriteria.value.searchTarget,
                                totalRecords: brandsAndMarkets.value.totalCount,
                                "page-index": pageNumber.value,
                                "page-size": pageSize.value,
                                onPageChange: _cache[0] || (_cache[0] = ($event) => (pageNumber.value = $event + 1))
                            }, {
                                anomalies: _withCtx((slotProps) => [
                                    _createElementVNode("span", null, [
                                        _createVNode(OneDeskAnomalyColumn, {
                                            "anomalies-count": slotProps.item
                                        }, null, 8, ["anomalies-count"])
                                    ])
                                ]),
                                _: 1
                            }, 8, ["table-data", "columns-definition", "grouped-value", "totalRecords", "page-index", "page-size"]))
                            : (inventory.value.items.length !== 0)
                                ? (_openBlock(), _createBlock(InventoryWebsitesTable, {
                                    key: 1,
                                    "data-testid": "inventory-websites-table",
                                    "table-data": inventory.value.items,
                                    "data-test": "inventory-sub-table",
                                    "columns-definition": columnsDefinitionSubTable.value,
                                    "has-pagination": true,
                                    "header-class": "website-table-header",
                                    "on-row-click": onWebsiteRowClick,
                                    "row-class": "rowClass",
                                    totalRecords: inventory.value.totalCount,
                                    "page-index": pageNumber.value,
                                    "page-size": pageSize.value,
                                    onPageChange: _cache[1] || (_cache[1] = ($event) => (pageNumber.value = $event + 1))
                                }, {
                                    siteName: _withCtx((slotProps) => [
                                        _createElementVNode("span", null, [
                                            _createVNode(WebSiteLink, {
                                                "displayed-website-url": slotProps.item?.siteName,
                                                "href-url": slotProps.item?.fullSiteName,
                                                "icon-type": "market",
                                                "icon-data": slotProps.item?.market
                                            }, null, 8, ["displayed-website-url", "href-url", "icon-data"])
                                        ])
                                    ]),
                                    anomalies: _withCtx((slotProps) => [
                                        _createElementVNode("span", null, [
                                            _createVNode(OneDeskAnomalyColumn, {
                                                "anomalies-count": slotProps.item.anomalies?.length ?? 0
                                            }, null, 8, ["anomalies-count"])
                                        ])
                                    ]),
                                    _: 1
                                }, 8, ["table-data", "columns-definition", "totalRecords", "page-index", "page-size"]))
                                : _createCommentVNode("", true),
                        (displayNoResult.value)
                            ? (_openBlock(), _createBlock(OneDeskInventoryNoResult, {
                                key: 2,
                                "data-testid": "inventory-no-result",
                                loading: loading.value
                            }, null, 8, ["loading"]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }, 8, ["search-text"])
            ], 512));
        };
    }
});
